module.exports = __webpack_public_path__ + "static/media/chart-area.89afee18.svg";